import { v4 as uuidv4 } from "uuid";

export const datenschutzData = [
  {
    id: uuidv4(),
    title: "1. Datenschutz auf einen Blick",
    text: [
      `Allgemeine Hinweise
    Die folgenden Hinweise geben einen einfachen Überblick darüber, 
    was mit Ihren personenbezogenen Daten passiert, wenn Sie unsere 
    Website besuchen. Personenbezogene Daten sind alle Daten, mit denen 
    Sie persönlich identifiziert werden können. Ausführliche Informationen 
    zum Thema Datenschutz entnehmen Sie unserer unter diesem Text aufgeführten 
    Datenschutzerklärung.`,
      `Wer ist verantwortlich für die Datenerfassung auf dieser Website?
    Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. 
    Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.`,
      `Wie erfassen wir Ihre Daten?
    Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. 
    um Daten handeln, die Sie in ein Kontaktformular eingeben.
    Andere Daten werden automatisch beim Besuch der Website durch unsere IT-Systeme erfasst. 
    Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des 
      Seitenaufrufs). Die Erfassung dieser Daten erfolgt automatisch, 
    sobald Sie unsere Website betreten.`,
      `Wofür nutzen wir Ihre Daten?
    Ein Teil der Daten wird erhoben, um eine 
    fehlerfreie Bereitstellung der Website zu gewährleisten. 
    Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.`,
      `Welche Rechte haben Sie bezüglich Ihrer Daten?
  Sie haben jederzeit das Recht unentgeltlich Auskunft über Herkunft, 
  Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. 
  Sie haben außerdem ein Recht, die Berichtigung, Sperrung oder Löschung dieser 
  Daten zu verlangen. Hierzu sowie zu weiteren Fragen zum Thema Datenschutz können 
  Sie sich jederzeit unter der im Impressum angegebenen Adresse an uns wenden. Des 
  Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen Aufsichtsbehörde zu.`,
      `Analyse-Tools und Tools von Drittanbietern
Beim Besuch unserer Website kann Ihr Surf-Verhalten 
statistisch ausgewertet werden. Das geschieht vor allem mit 
Cookies und mit sogenannten Analyseprogrammen. Die Analyse Ihres 
Surf-Verhaltens erfolgt in der Regel anonym; das Surf-Verhalten kann 
nicht zu Ihnen zurückverfolgt werden. Sie können dieser Analyse widersprechen 
oder sie durch die Nichtbenutzung bestimmter Tools verhindern. Detaillierte Informationen 
dazu finden Sie in der folgenden Datenschutzerklärung.`,
    ],
  },
  {
    id: uuidv4(),
    title: "2. Allgemeine Hinweise und Pflichtinformationen",
    text: [
      `Datenschutz`,
      `Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. 
    Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen 
    Datenschutzvorschriften sowie dieser Datenschutzerklärung.`,
      `Wenn Sie diese Website benutzen, 
    werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit 
    denen Sie persönlich identifiziert werden können. Die vorliegende Datenschutzerklärung erläutert, 
    welche Daten wir erheben und wofür wir sie nutzen. 
    Sie erläutert auch, wie und zu welchem Zweck das geschieht.`,
      `Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) 
  Sicherheitslücken aufweisen kann. 
  Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.`,
      `Hinweis zur verantwortlichen Stelle
Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:`,
      `Arno Setaghyan`,
      `Schwimmschule " Swimming from zero to hero" Steinmickerweg 6, 59505 Bad Sassendorf`,
      {
        name: "Telefon:",
        href: "tel:+ 49 17624310872",
        link: "+4917624310872",
      },
      {
        name: "E-Mail:",
        href: "mailto:swimmzerotohero@gmail.com",
        link: "swimmzerotohero@gmail.com",
      },
      `Widerruf Ihrer Einwilligung zur Datenverarbeitung
 Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. 
 Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Dazu reicht eine formlose
  Mitteilung per E-Mail an uns. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung 
  bleibt vom Widerruf unberührt.`,
    ],
  },
  {
    id: uuidv4(),
    title:
      "3. Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie gegen Direktwerbung (Art. 21 DSGVO)",
    text: [
      `Wenn die Datenverarbeitung auf Grundlage von Art. 
    6 Abs. 1 lit. e oder f DSGVO erfolgt, haben Sie jederzeit das Recht, 
    aus Gründen, die sich aus Ihrer besonderen Situation ergeben, gegen die Verarbeitung Ihrer 
    personenbezogenen Daten Widerspruch einzulegen; dies gilt auch für ein auf diese Bestimmungen 
    gestütztes Profiling. Die jeweilige Rechtsgrundlage, auf denen eine Verarbeitung beruht, 
    entnehmen Sie dieser Datenschutzerklärung. Wenn Sie Widerspruch einlegen, werden wir Ihre 
    betroffenen personenbezogenen Daten nicht mehr verarbeiten, es sei denn, wir können zwingende 
    schutzwürdige Gründe für die Verarbeitung nachweisen, die Ihre Interessen, Rechte und Freiheiten
     überwiegen oder die Verarbeitung dient der Geltendmachung, 
    Ausübung oder Verteidigung von Rechtsansprüchen (Widerspruch nach Art. 21 Abs. 1 DSGVO).`,
      `Werden Ihre personenbezogenen Daten verarbeitet, um Direktwerbung zu betreiben, 
  so haben Sie das Recht, jederzeit Widerspruch gegen die Verarbeitung Sie betreffender 
  personenbezogener Daten zum Zwecke derartiger Werbung einzulegen; dies gilt auch für das 
  Profiling, soweit es mit solcher Direktwerbung in Verbindung steht. Wenn Sie widersprechen, 
  werden Ihre personenbezogenen Daten anschließend nicht mehr zum Zwecke der Direktwerbung verwendet 
  (Widerspruch nach Art. 21 Abs. 2 DSGVO).`,
      `Beschwerderecht bei der zuständigen Aufsichtsbehörde
Im Falle datenschutzrechtlicher Verstöße steht dem Betroffenen ein Beschwerderecht bei der zuständigen 
Aufsichtsbehörde zu. Zuständige Aufsichtsbehörde in datenschutzrechtlichen Fragen ist der 
Landesdatenschutzbeauftragte des Bundeslandes, in dem unser Unternehmen seinen Sitz hat. Eine Liste der 
Datenschutzbeauftragten sowie deren Kontaktdaten können folgendem Link entnommen `,
      {
        name: "werden: ",
        link: "https://www.bfdi.bund.de/DE/Infothek/Anschriften_Links/anschriften_links-node.html.",
      },
      `Recht auf Datenübertragbarkeit
Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines 
Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem gängigen, 
maschinenlesbaren Format aushändigen zu lassen. Sofern Sie die direkte Übertragung der 
Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.`,
      `SSL- bzw. TLS-Verschlüsselung
Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, 
wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns als Seitenbetreiber senden, 
eine SSL-bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass 
die Adresszeile des Browsers von “http://” auf “https://” wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln, 
nicht von Dritten mitgelesen werden.`,
      `Auskunft, Sperrung, Löschung
Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf 
unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft 
und Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung, 
Sperrung oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene 
Daten können Sie sich jederzeit unter der im Impressum angegebenen Adresse an uns wenden.
 `,
    ],
  },
  {
    id: uuidv4(),
    title: "4. Datenerfassung auf unserer Website",
    text: [
      `Cookies
    Die Internetseiten verwenden teilweise so genannte Cookies. Cookies richten 
    auf Ihrem Rechner keinen Schaden an und enthalten keine Viren. Cookies dienen dazu, 
    unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen. Cookies sind kleine 
    Textdateien, die auf Ihrem Rechner abgelegt werden und die Ihr Browser speichert.`,
      `Die meisten der von uns verwendeten Cookies sind so genannte “Session-Cookies”. 
  Sie werden nach Ende Ihres Besuchs automatisch gelöscht. Andere Cookies bleiben 
  auf Ihrem Endgerät gespeichert bis Sie diese löschen. Diese Cookies ermöglichen es uns, 
  Ihren Browser beim nächsten Besuch wiederzuerkennen.`,
      `Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden 
und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell 
ausschließen sowie das automatische Löschen der Cookies beim Schließen des Browser aktivieren. 
Bei der Deaktivierung von Cookies kann die Funktionalität dieser Website eingeschränkt sein.`,
      `Cookies, die zur Durchführung des elektronischen Kommunikationsvorgangs oder zur 
Bereitstellung bestimmter, von Ihnen erwünschter Funktionen (z.B. Warenkorbfunktion) 
erforderlich sind, werden auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO gespeichert. 
Der Websitebetreiber hat ein berechtigtes Interesse an der Speicherung von Cookies 
zur technisch fehlerfreien und optimierten Bereitstellung seiner Dienste. Soweit 
andere Cookies (z.B. Cookies zur Analyse Ihres Surfverhaltens) gespeichert werden, 
werden diese in dieser Datenschutzerklärung gesondert behandelt.`,
      `Server-Log-Dateien`,
      `Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten
 Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:`,
      `Browsertyp und Browserversion
`,
      `verwendetes Betriebssystem`,
      `Referrer URL`,
      `Hostname des zugreifenden Rechners`,
      `Uhrzeit der Serveranfrage`,
      `IP-Adresse`,
      `Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.`,
      `Grundlage für die Datenverarbeitung ist Art. 6 Abs. 1 lit. b DSGVO, 
der die Verarbeitung von Daten zur Erfüllung eines Vertrags oder vorvertraglicher Maßnahmen gestattet.`,
      `Kontaktformular
`,
      `Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular 
inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für 
den Fall von Anschlussfragen bei uns gespeichert. 
Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.`,
      `Die Verarbeitung der in das Kontaktformular 
eingegebenen Daten erfolgt somit ausschließlich auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO). 
Sie können diese Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns. 
Die Rechtmäßigkeit der bis zum Widerruf 
erfolgten Datenverarbeitungsvorgänge bleibt vom Widerruf unberührt.`,
      `Die von Ihnen im Kontaktformular 
eingegebenen Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur 
Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt (z.B. nach abgeschlossener 
  Bearbeitung Ihrer Anfrage). Zwingende 
gesetzliche Bestimmungen - insbesondere Aufbewahrungsfristen - bleiben unberührt.`,
    ],
  },
  {
    id: uuidv4(),
    title: "5. PLUGINS UND TOOLS",
    text: [
      `Browser Plugin`,
      `Sie können die Speicherung der Cookies durch eine entsprechende 
    Einstellung Ihrer Browser-Software verhindern; wir weisen Sie jedoch darauf hin, dass 
    Sie in diesem Fall gegebenenfalls nicht sämtliche Funktionen dieser Website vollumfänglich 
    werden nutzen können. Sie können darüber hinaus die Erfassung der durch den Cookie erzeugten 
    und auf Ihre Nutzung der Website bezogenen Daten (inkl. Ihrer IP-Adresse) an Google sowie 
    die Verarbeitung dieser Daten durch Google verhindern, 
    indem Sie das unter dem folgenden Link verfügbare Browser-Plugin herunterladen und `,
      {
        name: "installieren:",
        link: "https://tools.google.com/dlpage/gaoptout?hl=de",
      },
      `Google Web Fonts
    Diese Seite nutzt zur einheitlichen Darstellung von Schriftarten so 
    genannte Web Fonts, die von Google bereitgestellt werden. Beim Aufruf 
    einer Seite lädt Ihr Browser die benötigten 
    Web Fonts in ihren Browsercache, um Texte und Schriftarten korrekt anzuzeigen.`,
      `Zu diesem Zweck muss der von Ihnen verwendete Browser Verbindung zu den Servern 
    von Google aufnehmen. Hierdurch erlangt Google Kenntnis darüber, dass über Ihre 
    IP-Adresse unsere Website aufgerufen wurde. Die Nutzung von Google Web Fonts erfolgt 
    im Interesse einer einheitlichen und ansprechenden Darstellung unserer Online-Angebote. 
    Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar.
    Wenn Ihr Browser Web Fonts nicht unterstützt, wird eine Standardschrift von Ihrem Computer genutzt.`,
      `
    Weitere Informationen zu Google Web Fonts finden Sie`,
      {
        name: "unter",
        link: "https://developers.google.com/fonts/faq",
      },
      {
        name: "Google:",
        link: "https://policies.google.com/privacy?hl=de",
      },
    ],
  },
];
